import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import CheckIcon from '@mui/icons-material/Check';
import CreateIcon from '@mui/icons-material/Create';

import { useTheme } from 'contexts/ThemeContext';

import { Text } from 'components/DataDisplay';
import { TextField } from 'components/Inputs';
import { Item } from 'components/Layout';

export const InlineIdEditor = ({ value, onSave }) => {
  const { themeColors } = useTheme();
  const { designSystem } = themeColors;
  const [isEditing, setIsEditing] = useState(false);
  const [draft, setDraft] = useState('');
  const [savedValue, setSavedValue] = useState(value || '');

  useEffect(() => {
    setSavedValue(value || '');
  }, [value]);

  const startEditing = () => {
    setDraft(savedValue);
    setIsEditing(true);
  };

  const validate = (nextValue = draft) => {
    setSavedValue(nextValue);
    onSave(nextValue);
    setIsEditing(false);
  };

  if (isEditing) {
    return (
      <Item
        flex
        onClick={event => event.stopPropagation()}
        style={{ alignItems: 'center', gap: '4px' }}
      >
        <Item flex style={{ width: '150px' }}>
          <TextField
            value={draft}
            placeholder="ID après setup"
            onChange={setDraft}
            onEnter={validate}
            small
          />
        </Item>
        <CheckIcon
          onClick={() => validate()}
          style={{
            fontSize: '17px',
            color: designSystem.green,
            cursor: 'pointer'
          }}
        />
      </Item>
    );
  }

  return (
    <Item
      flex
      onClick={event => event.stopPropagation()}
      style={{ alignItems: 'center', gap: '3px' }}
    >
      <Text
        component="span"
        fontSize="11.5px"
        style={{
          color: savedValue ? designSystem.muted : designSystem.faint,
          whiteSpace: 'nowrap'
        }}
      >
        {savedValue ? `ID : ${savedValue}` : 'ID après setup'}
      </Text>
      <CreateIcon
        onClick={startEditing}
        style={{
          fontSize: '14px',
          color: designSystem.faint,
          cursor: 'pointer'
        }}
      />
    </Item>
  );
};

InlineIdEditor.defaultProps = {
  value: ''
};

InlineIdEditor.propTypes = {
  value: PropTypes.string,
  onSave: PropTypes.func.isRequired
};

export default InlineIdEditor;
